type Props = {
  onDone: () => void;
};

/** Closing frame after the buyer completes the review flow. */
export function BuyerClosingCongratulationsStep({ onDone }: Props) {
  return (
    <section
      className="panel border-[#a9c8b9] bg-[#edf4f0] text-center"
      data-testid="buyer-closing-congratulations"
    >
      <div className="mx-auto flex h-14 w-14 items-center justify-center rounded-full bg-[#1f6b57] text-2xl font-bold text-white">
        ✓
      </div>
      <p className="mt-4 text-sm text-[#36594d]">Recorded for office review.</p>
      <button className="button-primary mt-6" type="button" onClick={onDone}>
        View final receipt
      </button>
    </section>
  );
}
